export default "__VITE_ASSET__DE2oQveB__"